import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import debug from '../../services/debug';
import App from '../app/container';

interface Props {
  handleSetActionApprovalDocIDRoute: (id: string | undefined) => void;
}

function ActionApprovalDocRouter({ handleSetActionApprovalDocIDRoute }: Props) {
  const { ActionApprovalDocID } = useParams();

  debug('ActionApprovalDocRouter ActionApprovalDocID', ActionApprovalDocID);

  useEffect(() => {
    handleSetActionApprovalDocIDRoute(ActionApprovalDocID);
  }, []);

  return <App />;
}

export default ActionApprovalDocRouter;
